import { render, staticRenderFns } from "./changeUserPass.vue?vue&type=template&id=392b6bdd&scoped=true&lang=html&"
import script from "./changeUserPass.vue?vue&type=script&lang=js&"
export * from "./changeUserPass.vue?vue&type=script&lang=js&"
import style0 from "./changeUserPass.vue?vue&type=style&index=0&id=392b6bdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392b6bdd",
  null
  
)

export default component.exports